import React, {useMemo, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import {toast} from "react-toastify";
import projectUtils from "../../../../utils/project-utils.js";
import Swal from "sweetalert2";
import {useParams} from "react-router";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import routeService from "../../../../services/web/route-service.js";
import RouteImage from "../components/route-image.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import Alert from "../../../../components/alert/alert.jsx";

const typeRouteOpt = [
    {value: "ENTRANCE" , label: "Entrada de área monitorada" },
    {value: "EXIT" , label: "Saída de área monitorada" },
    {value: "INTERNAL" , label: "Interno a área monitorada" },
    {value: "EXTERNAL" , label: "Externo a área monitorada" },
]

const initialState = {
    description: "",
    regionType: ""
}
const BASENAME = import.meta.env.BASE_URL;

const RouteForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [state, setState] = useState(initialState)
    const [lanes, setLanes] = useState([])
    const gridRef = useRef(null);
    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    const columnDefs = [
        {headerName: "Câmeras ativas", field: "activeLanes", flex: 1},
        {headerName: "Câmeras inativas", field: "inactiveLanes", flex: 1}
    ];

    const handleInputs = (id, value) => setState(prev => ({...prev, [id]: value}));

    const onChange = ({target: {value, id}}) => setState(prev => ({...prev, [id]: value}))

    const { refetch, isLoading } = useQuery({
        queryFn: () =>  routeService.getById(id).then((data) => {
            setLanes([{
                activeLanes: data.activeLanes,
                inactiveLanes: data.inactiveLanes,
            }])
            setState(data.route)
            return data
        }),
        queryKey: ['route'],
        enabled: !!id,
    });

    const save = () => {
        if (!validateForm()) {
            return;
        }

        const formData = new FormData();

        const preparedState = {
            ...(id && { code: state.code,  }),
            description: state.description,
            regionType: state.regionType,
            procedureImageid: state.procedureImageid ?? null
        }

        const  formJson = JSON.stringify(preparedState)
        const formBlob = new Blob([formJson], {
            type: 'application/json'
        });

        formData.append("route", formBlob);
        formData.append("file", state.attach ?? null);

        const response = !!id ? routeService.edit(formData) : routeService.create(formData);
        response
            .then((data) => {
                projectUtils.success(!id);

                if (id) {
                    refetch();
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                const errData = error.response?.data;

                if (errData === "descriptionRoute.already.registered") {
                    message = "Este \"Nome\" já está sendo utilizado.";
                }

                projectUtils.swalErrorMessage("", message, "Ok");
            })
    }

    const validateForm = () => {
        if (!state.description){
            projectUtils.swalErrorMessage("", 'O campo "Nome" é obrigatório.' , "Ok");
            return false;
        }

        if (!state.regionType){
            projectUtils.swalErrorMessage("", 'O campo "Tipo" é obrigatório.' , "Ok");
            return false;
        }

        return true
    }

    const destroy = () => {
        Swal.fire({
            title: "Excluir",
            text: `Excluir o sentido "${state.description}"?`,
            icon: "warning",
            confirmButtonText: "Sim",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Não",
            cancelButtonColor: "#c10007",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                routeService.destroy(id).then(() => {
                    navigateToList()
                    projectUtils.success(true, "Excluído com sucesso")
                })
            }
        });
    }
    const newRoute = () => {
        let isBlank = false;
        let urlDev = `/route/form`;
        navigate(urlDev, isBlank);
    }

    const navigateToEdit = (data) => {
        let isBlank = false;
        let urlDev = `/route/form/${data}`;
        navigate(urlDev, isBlank);
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/route`;
        navigate(urlDev, isBlank);
    }

    const onCellClicked = (data) => {
        const searchLanes = data.colDef.field === "activeLanes" ? data.data.activeLanes : data.data.inactiveLanes

        if (searchLanes){
            localStorage.setItem('lanes', searchLanes);
            window.open(`${BASENAME}lanes`);
        }
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Sentido
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={() => newRoute()}>
                            <FaPlus/>
                            Adicionar sentido
                        </Button>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card >
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-10 relative">
                                <div className={"grid grid-cols-12 gap-4"}>
                                    <div className="col-span-12">
                                        <InputForm id="description" value={state.description} onChange={onChange}
                                                   label="Nome *"/>
                                    </div>
                                    <div className="col-span-12">
                                        <SelectComponent
                                            name="regionType"
                                            value={state.regionType}
                                            options={typeRouteOpt}
                                            label={"Tipo *"}
                                            onChange={(selected) => handleInputs("regionType", selected?.value)}
                                        />
                                    </div>
                                    {id &&
                                        <div className="col-span-6 flex">
                                            <div className={"h-[83px] w-full p-0 ag-theme-quartz"}>
                                                <AgGridReact
                                                    ref={gridRef}
                                                    rowHeight={40}
                                                    rowData={lanes}
                                                    columnDefs={columnDefs}
                                                    animateRows={false}
                                                    suppressCellFocus={true}
                                                    onCellClicked={onCellClicked}
                                                    gridOptions={{localeText: aggridUtils.localization()}}
                                                    theme={theme}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-span-2">
                                <RouteImage setState={setState} state={state} />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    (lanes[0]?.activeLanes || lanes[0]?.inactiveLanes) &&
                                    <Alert target="warning" className={"flex h-[32px] items-center"}>Não é possível excluir, pois existem câmeras dependentes do sentido.</Alert>
                                }
                                {
                                    id &&
                                    <>
                                        <Button target="danger" onClick={destroy} disabled={lanes[0]?.activeLanes || lanes[0]?.inactiveLanes} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType='save'>

                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>

        </Template>
    );
};

export default RouteForm;